module.exports = __webpack_public_path__ + "static/media/mzc.4f5ab18a.svg";